"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styled_1 = __importDefault(require("../utils/styled"));
const fadeIn = core_1.keyframes `
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;
exports.Overlay = styled_1.default("div") `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  animation: ${fadeIn} 0.1s ease-in;
  z-index: ${({ theme, type }) => (type === "confirm" ? theme.zIndex.confirm : theme.zIndex.modal) - 1};
`;
exports.default = exports.Overlay;
//# sourceMappingURL=Overlay.js.map